import keyMirror from 'src/utilities/keyMirror';

export const ACTION_TYPES = keyMirror({
  SET_FILE_DATA: null,

  SET_FILE_DATA_ERROR: null,

  SET_LIST_PARTNER_USER_ID_DATA: null,

  SET_LIST_PARTNER_TX_ID_DATA: null,

  SET_LIST_PARTNER_USER_ID_ERROR_DATA: null,

  SET_LIST_PARTNER_TX_ID_ERROR_DATA: null,

  SET_IS_DATA_VALIDATED: null,

  SET_IS_VALIDATION_FINISHED: null,

  SET_IS_DATA_TABLE_INPUT_ERROR: null,

  SET_ENABLED_MODAL_VALIDATE_BUTTON: null,

  SET_LIST_PARTNER_USER_AND_TX_ID_FROM_ERROR_DATA: null,

  SET_RESPONSE_VALIDATION_DATA_SUCCESS: null,

  SET_RESPONSE_VALIDATION_DATA_ERROR: null,

  RESET_FILE_VALIDATION_DATA_ERROR: null,

  SET_IS_MODAL_VALIDATE_BUTTON_CLICKED: null,

  RESET_UPLOADED_DATA: null,

  RESET_ALL_DATA_VALIDATED: null,

  GET_LIMIT_CREATION_VA: null,
  GET_LIMIT_CREATION_VA_SUCCESS: null,
  GET_LIMIT_CREATION_VA_FAILED: null,

  SET_FILE_SUBMIT: null,

  SET_RESPONSE_SUBMIT_DATA_ERROR: null,

  SET_TOTAL_INVALID_ROW_AND_EMPTY_INPUT: null,

  SET_HAS_NOTIFY_FAILED_CREATE_VA: null,

  UPDATE_RESPONSE_VALIDATION_ERROR_DATA: null,
});
